<template>
    <show-base-template v-on:edit='openEdit()' v-on:delete='deleteItem()' :item='item' :errors='errors' :allowedit='true' :title='title'>
        <template v-if='item.id' v-slot:body>

            <div class="form-group d-flex align-items-center">
                <div class="col-6">{{ $t('translations.name') | capitalise }}: </div><div class="col-18"> {{item.name}}</div>
            </div>
            <div class="form-group d-flex align-items-center">
                <div class="col-6">{{ $t('translations.start_at') | capitalise }}: </div><div class="col-18"> {{item.start_at | formatDateTime }}</div>
            </div>
            <div class="form-group d-flex align-items-center">
                <div class="col-6">{{ $t('translations.end_at') | capitalise }}: </div><div class="col-18"> {{item.end_at | formatDateTime }}</div>
            </div>

            <hr>

            <h4>Campaign Statistics</h4>

            <div class="form-group d-flex align-items-center">
                <div class="col-6">{{ $t('translations.total_users') | capitalise }}: </div><div class="col-18"> {{stats.total_users}}</div>
            </div>

            <div class="form-group d-flex align-items-center">
                <div class="col-6">{{ $t('translations.invite_sent') | capitalise }}: </div><div class="col-18"> {{stats.invite_sent}}</div>
            </div>

            <div class="form-group d-flex align-items-center">
                <div class="col-6">{{ $t('translations.completed') | capitalise }}: </div><div class="col-18"> {{stats.completed}}</div>
            </div>

            <div class="form-group d-flex align-items-center">
                <div class="col-6">{{ $t('translations.reminder_sent') | capitalise }}: </div><div class="col-18"> {{stats.reminder_sent}}</div>
            </div>

            <hr>
            <h4>Campaign Control</h4>

            <div class='d-flex flex-row'>
                <button :disabled='moment(item.start_at).isSameOrBefore(now, "minute")' class="btn btn-success btn-round btn-dispointer mr-1" role="button" 
                    v-on:click="start_campaign">{{ $t('translations.start_campaign') | capitalise}}</button>
                <button :disabled='!(item.start_at && moment(item.start_at).isSameOrBefore(now, "minute") && (!item.end_at || moment(item.end_at).isAfter(now, "minute")))' class="btn btn-warning btn-round btn-dispointer mr-1" role="button" 
                    v-on:click="stop_campaign">{{ $t('translations.stop_campaign') | capitalise}}</button>
                <button :disabled='!(item.end_at && moment(item.end_at).isSameOrBefore(now, "minute"))' class="btn btn-danger btn-round btn-dispointer mr-1" role="button" 
                    v-on:click="reset_campaign">{{ $t('translations.reset_campaign') | capitalise}}</button>
                <button :disabled='!(item.reminder_title && item.reminder_message && item.reminder_call_to_action && item.start_at && moment(item.start_at).isSameOrBefore(now, "minute") && (!item.end_at || moment(item.end_at).isAfter(now, "minute")))' class="btn btn-info btn-round btn-dispointer mr-1" role="button" 
                    v-on:click="send_reminder">{{ $t('translations.send_reminder') | capitalise}}</button>
                
            </div>    

            <!-- <div class="form-group d-flex align-items-center">
                <div class="align-self-start col-6">{{ $t('translations.user_imports') | capitalise }}: </div>
                <div class="col-18">
                        <div :key='user_import.id' v-for='user_import in item.user_import'>
                            <div>{{ user_import.created_at | formatDateTime }}</div>
                            <ul>
                                <li>{{ $t('translations.new_users') }}: {{ user_import.new_users }}</li>
                                <li>{{ $t('translations.bad_data_users') }}: {{ user_import.bad_data_users }}</li>
                                <li>{{ $t('translations.existing_users') }}: {{ user_import.existing_users }}</li>
                                <li>{{ $t('translations.in_other_provider_users') }}: {{ user_import.in_other_provider_users }}</li>
                            </ul>
                        </div>
                </div>
            </div> -->


        </template>
        <!-- <template v-if='item.id' v-slot:footer>
            <footer class='container-footer'>
                <button class="btn btn-primary btn-round float-right" v-on:click.prevent='openEdit()' role="button">{{ $t('translations.edit')}}</button>
                <button class="btn btn-danger btn-round mr-1 float-right" role="button" v-on:click.prevent='$emit("delete")'>{{ $t('translations.delete')}}</button>
            </footer>
        </template> -->
    </show-base-template>
</template>

<script>
	export default {
        extends: app.base.showBase,
        props: [
        ],

        data() {
            return {
                event: "campaign",
                model: "campaign",
                title: "Campaign",
                path: 'campaigns',
                route: '/api/v1/campaigns',
                allowedit: true,
                now: this.moment.now(),
                timer: null,
                stats: {},
            };
        },
        mounted() {
            this.timer = setInterval(() => {
                this.now = this.moment.now()
            }, 1000);
        },
        unmounted() {
            clearInterval(this.timer);
        },
        methods: {
            loadItem() {
                this.setLoading(true);

                axios.get(this.route + `/${this.$route.params.id}/1`).then((res) => {
					this.item = res.data[this.model];
                    this.stats = res.data["stats"];

                    this.setLoading(false);
				}).catch((error) => {
                    this.setLoading(false);
                    this.handleError(error, "load");
                    this.$router.push({path: "/" + this.event + "-list"});
                });
            },
            start_campaign() {
                this.setLoading(true);
                axios.put(this.route + '/start/' + this.item.id, this.item).then((res) => {
                    this.item.start_at = res.data.start_at;
                    this.item.end_at = res.data.end_at;
                    //console.log(res.data);
                    this.setLoading(false);
                    this.addNotification({type: "success", content: this.$t("translations.campaign_started", {name: this.item.name})});
                }).catch((error) => {
                    this.setLoading(false);
                    this.handleError(error, "start");
                });
            },
            stop_campaign() {
                this.setLoading(true);
                axios.put(this.route + '/stop/' + this.item.id, this.item).then((res) => {
                    this.item.end_at = res.data.end_at;
                    //console.log(res.data);
                    this.setLoading(false);
                    this.addNotification({type: "success", content: this.$t("translations.campaign_stopped", {name: this.item.name})});
                }).catch((error) => {
                    this.setLoading(false);
                    this.handleError(error, "start");
                });
            },
            reset_campaign() {
                this.setLoading(true);
                axios.put(this.route + '/reset/' + this.item.id, this.item).then((res) => {
                    this.item.start_at = res.data.start_at;
                    this.item.end_at = res.data.end_at;
                    //console.log(res.data);
                    this.setLoading(false);
                    this.addNotification({type: "success", content: this.$t("translations.campaign_reset", {name: this.item.name})});
                }).catch((error) => {
                    this.setLoading(false);
                    this.handleError(error, "start");
                });
            },
            send_reminder() {
                this.setLoading(true);
                axios.put(this.route + '/reminder/' + this.item.id, this.item).then((res) => {
                    this.item.reminder_at = res.data.reminder_at;
                    //console.log(res.data);
                    this.setLoading(false);
                    this.addNotification({type: "success", content: this.$t("translations.campaign_reminder_at", {name: this.item.name})});
                }).catch((error) => {
                    this.setLoading(false);
                    this.handleError(error, "start");
                });
            },
        }
    };
</script>
